import ApiService from "../../../services/api";
import moment from "moment";
import helpers from "../../../shared/fleetbox-helpers";
import property from '../chartProperties';

export default {
	data: function() {
		return {
			/* Km Traveled */
			pdfOptions: {
				landscape: true,
				fileName: "KM Percorsi",
				title: "KM PERCORSI"
			},
			kmTraveledModal: false,
			titleChart: "",
			legend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var color = property.kmTraveled.color; //e.options.markers.background;
						var labelColor = e.options.labels.color;
						var rect = new kendo.geometry.Rect([0, 0], [200, 200]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						var marker = new kendo.drawing.Path({
							fill: {
								color: color
							},
							stroke: {
								color: color
							}
						})
							.moveTo(0, 0)
							.lineTo(0, 10)
							.lineTo(30, 10)
							.lineTo(30, 0)
							.close();

						var label = new kendo.drawing.Text(e.series.name, [0, 0], {
							fill: {
								color: labelColor
							},
							font: "13px 'Montserrat Light', montserrat-light !important"
						});

						layout.append(marker, label);
						layout.reflow();

						return layout;
					}
				}
			},
			kmTraveled: [
				{
					name: "KM PERCORSI",
					field: "value",
					labels: {
						visible: true,
						background: "none",
						format: "n2",
						font: "10px montserrat-light"
					}
				}
			],
			kmTraveledData: [],
			kmTraveledTooltip: {
				visible: true,
				template: "Km percorsi dal #= dataItem.from # al #= dataItem.to #: #= kendo.toString(value, 'n2') #"
			},
			kmTraveledCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				line: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			kmTraveledValueAxis: [
				{
					//max: 2000,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					labels: {
						rotation: "auto",
						visible: false,
						font: "10px montserrat-light"
					}
				}
			],
			kmTraveledValueAxisModal: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "KM",
						rotation: 0,
						font: "10px montserrat-light"
					},
					labels: {
						format: "n0",
						font: "10px montserrat-light"
					}
				}
			],
			kmTraveledModalIndex: 0,
			modalTitle: "Km percorsi da",
			loading: true
			/* Km Traveled */
		};
	},
	watch: {},
	created() {
		this.getTripsCounter();
	},
	methods: {
		kmTraveledClickHandler() {
			this.kmTraveledModal = true;
			$(".k-tooltip.k-chart-tooltip").remove();
			setTimeout(() => {
				this.kmTraveledModalIndex++;
			}, 200);
		},
		/* Trips Counter */
		getTripsCounter() {
			var self = this;
			ApiService.getTripsCounter().then(res => {
				self.getUserFriendlyTripsCounter(res);
			});
		},

		getUserFriendlyTripsCounter(data) {
			var self = this;
			if (data && data.length > 0) {
				var maxKmValue = _.maxBy(data, function(o) {
					return o.values.km;
				}).values.km;

				var maxDate = _.maxBy(data, function(o) {
					return moment(o.to);
				}).to;

				var minDate = _.minBy(data, function(o) {
					return moment(o.from);
				}).from;

				this.modalTitle = `Km percorsi dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))} (settimanale)`;
				this.pdfOptions.title = `Km percorsi dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))}`;
				this.pdfOptions.fileName = helpers.chartPdffileName(this, "Km_percorsi", minDate, maxDate);
				data.forEach(function(item) {
					self.kmTraveledCategoryAxis.categories.push(self.$options.filters.dateToString(item.from));

					var pKm = (item.values.km * 100) / maxKmValue;
					var percentageKm = pKm / 100;
					var colorKmValue = property.kmTraveled.color;//self.pickHex([0, 51, 255], [52, 164, 235], percentageKm);

					self.kmTraveledData.push({
						from: self.$options.filters.dateToString(item.from),
						to: self.$options.filters.dateToString(item.to),
						value: item.values.km,
						color: colorKmValue,//`rgb(${colorKmValue})`,
						name: "KM PERCORSI"
					});
				});
			}

			setTimeout(function() {
				self.loading = false;
			}, 200);
		},
		/* Trips Counter */

		//#region Utils
		pickHex(color1, color2, weight) {
			var w1 = weight;
			var w2 = 1 - w1;
			var rgb = [Math.round(color1[0] * w1 + color2[0] * w2), Math.round(color1[1] * w1 + color2[1] * w2), Math.round(color1[2] * w1 + color2[2] * w2)];
			return rgb;
		},

		exportAsPdf() {
			//var chart = this.$refs.chartKmTraveledModal.kendoWidget();
			//chart.saveAsPDF();

			var container = $("<div />")
				.css({
					position: "absolute",
					top: 0,
					left: -1500,
					height: 600
				})
				.appendTo("body");

			function cleanup() {
				container.getKendoChart().destroy();
				container.remove();
			}

			this.createChart(container, {
				// Custom settings for export
				transitions: false,

				// Cleanup
				render: function(e) {
					e.sender.saveAsPDF();
					setTimeout(cleanup, 500);
				}
			});
		},

		createChart(container, exportOptions) {
			var self = this;

			var options = {
				pdf: self.pdfOptions,
				theme: "metro",
				title: {
					text: self.modalTitle.toUpperCase(),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					visible: true,
					position: "bottom",
					item: {
						visual: function(e) {
							var color = property.kmTraveled.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;
							var rect = new kendo.geometry.Rect([0, 0], [200, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name, [0, 0], {
								fill: {
									color: labelColor
								},
								font: "13px 'Montserrat Light', montserrat-light"
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.kmTraveledData
				},
				series: [
					{
						field: "value",
						name: "KM PERCORSI",
						labels: {
							visible: true,
							font: "13px montserrat-light",
							format: "n2"
						}
					}
				],
				valueAxis: {
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "KM",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						font: "13px montserrat-light",
						format: "n0"
					}
				},
				categoryAxis: {
					categories: self.kmTraveledCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			options = $.extend(true, options, exportOptions);
			container.kendoChart(options);
		},

		exportAsXlsx(type) {
			var self = this;
			ApiService.exportAnalyticsXlsx("km", type).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Km percorsi.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		}
		//#endregion
	}
};
